export const shapesScheme: string[] = ['rectangle', 'line', 'ellipse'];
